<template>
  	<div class="top">
    <div class="logo">
          <img src="../assets/images/zhao.png" alt="">
          <span>O2O管理系统</span>
    </div>
     <div class="topNav_right">
        <a><img src="../assets/images/wode.png" style="display:inline-block;width:22px;height:22px;position:relative;top:5px;"/></a>
        <a style="color: #F7EAB7 ">当前登录名：<span style="color: #FFF;">{{userName}}</span></a> &nbsp;
        <a style="color: #F7EAB7 ">当前用户名：<span style="color: #FFF;">{{contact}}</span></a> &nbsp;
        
        <a href="javascript::" class="home-exit" @click="loginOut"><img src="../assets/images/anquantuichu.png"/><span>安全退出</span></a>
        <a class="home-code"> <img src="../assets/images/mima.png"/> </a>  
    </div> 
  </div>


</template>

<script>
import methods from '../homeDataMethods/homeMethods'
import axios from 'axios'
export default {
  name: 'app',
  data () {
    return {
      userName:"",
      contact:"",
      psd:"",
      urls:"http://192.168.0.58:8888/"
    }
  },
   mounted: function () {
      this.userName = window.localStorage.getItem("userName");
      this.contact = window.localStorage.getItem("contact");
    //   this.psd = window.localStorage.getItem("psd");

      console.log(this.userName,"组件挂载+++")
        
        //     axios({
        //         method:"POST",
        //         url:this.urls+"funding/fundingVerifyNamePWd",
        //         headers: {
        //             'X-Requested-With': 'XMLHttpRequest',
        //             'Content-Type': 'application/json; charset=UTF-8'
        //         },
        //         data:{
        //             userName:this.userName,
        //             passWord: this.psd
        //         }
        //     })
        //   .then(function (res) {
        //     console.log(res);
        //      if(res.data.success=="Y"){
        //           localStorage.setItem("userName","");
        //           localStorage.setItem("psd","");  
        //           console.log("登录成功++++++++++++")             
        //       }else {
               
        //             window.location.href='login2.html';                     
                
        //         //alert("请先登录")
        //      }

        //   })
        //   .catch(function (response) {
        //       console.log(response);

        //   })
  
      },
   methods: {
       loginOut(){
          window.location.href='login2.html';
          this.token = "";
       }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .top{
        width: 100%;
        height: 50px;

    }
    .logo{
        float: left;
        color: white;
        font-family: cursive;
        font-size: 16px;
        font-weight: 700;
        height: 100%;
        margin-left: 50px;
        line-height: 64px;
    }
    .topNav_right{
        float: right;
       
        height: 100%;
        line-height: 50px;
    }
    .topNav_right a{
        font-size: 14px;
        padding-right: 15px
    }
    .topNav_right a img{
        width: 22px;
    }
    
    .home-exit{
        float: right;
        display: block;
        width: 90px;
        height: 100%;
        text-align: center;
        overflow: hidden;
        padding: 0 !important;
    }
    .home-exit>img {
        
        display: block;
        margin: 5px auto;
    }
    .home-exit>span {
        position: relative;
        top: -18px;
        color: #FFF;
    }
    .home-code{
        width: 40px;
        height: 100%;
        float: right;
        display: block;
    }
    .home-code>img {
       
      
        margin: 12px auto;
    }
</style>



// WEBPACK FOOTER //
// src/components/topLogo.vue